module.exports = __webpack_public_path__ + "media/alerta.a85c8c44.wav";